var render = function render(){var _vm=this,_c=_vm._self._c;return _c('survey-management',{attrs:{"title":"label_sideMenu_violenceSurvey_surveyManagement","template-id":"ViolenceSurvey","background-color":"#f5fafd"}})
}
var staticRenderFns = []

export { render, staticRenderFns }